export var InputVariant;
(function (InputVariant) {
    InputVariant["FILLED"] = "filled";
    InputVariant["ERROR"] = "error";
    InputVariant["SUCCESS"] = "success";
    InputVariant["READONLY"] = "readonly";
})(InputVariant || (InputVariant = {}));
//# sourceMappingURL=Input.types.js.map